/**
 * ropa.ts — Categoría "Ropa" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_ropa",
  skuPrefix: "ROP",
  categoria: "Ropa",
} as const;

export const cat_ropa_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Camiseta Básica Hombre Blanca",
    marca: "Gef",
    modelo: "Basic Crew",
    origen: "Colombia",
    costo: 18500,
    precio: 32500,
    stock: 60,
    stockMinimo: 15,
    stockMaximo: 120,
    unidad: "unidad",
    ubicacionFisica: "Percha R1",
    proveedor: "Crystal S.A.S.",
    material: "100% algodón",
    colorProducto: "Blanco",
    talla: "M",
    descripcionLarga:
      "Camiseta básica unisex cuello redondo, algodón peinado suave, corte regular. Ideal para uso diario.",
    especificaciones: [
      { clave: "Material", valor: "100% algodón" },
      { clave: "Cuello", valor: "Redondo" },
    ],
    imageKeywords: ["white-tshirt", "basic-tshirt", "cotton-shirt"],
    color: "bg-white",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Jean Hombre Slim Azul",
    marca: "Chevignon",
    modelo: "Slim Fit 505",
    origen: "Colombia",
    costo: 55000,
    precio: 89900,
    stock: 35,
    stockMinimo: 8,
    stockMaximo: 70,
    unidad: "unidad",
    ubicacionFisica: "Percha R2",
    proveedor: "Chevignon Colombia",
    material: "98% algodón, 2% elastano",
    colorProducto: "Azul índigo",
    talla: "32",
    descripcionLarga:
      "Jean masculino corte slim fit con toque de elastano para comodidad. 5 bolsillos clásicos, cierre cremallera.",
    especificaciones: [
      { clave: "Corte", valor: "Slim fit" },
      { clave: "Material", valor: "Denim stretch" },
    ],
    imageKeywords: ["blue-jeans", "slim-jeans", "mens-denim"],
    color: "bg-blue-700",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Blusa Mujer Manga Larga",
    marca: "Studio F",
    modelo: "Chiffon Flowy",
    origen: "Colombia",
    costo: 32500,
    precio: 52500,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "unidad",
    ubicacionFisica: "Percha R3",
    proveedor: "Studio F Internacional",
    material: "100% poliéster chiffon",
    colorProducto: "Rosa palo",
    talla: "S",
    descripcionLarga:
      "Blusa de chiffon con manga larga y cuello redondo, caída fluida. Ideal oficina o eventos. Lavado a mano.",
    especificaciones: [
      { clave: "Material", valor: "Chiffon" },
      { clave: "Manga", valor: "Larga" },
    ],
    imageKeywords: ["womens-blouse", "chiffon-blouse", "pink-blouse"],
    color: "bg-pink-300",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Vestido Casual Mujer Floral",
    marca: "Studio F",
    modelo: "Summer Midi",
    origen: "Colombia",
    costo: 65000,
    precio: 98900,
    stock: 28,
    stockMinimo: 7,
    stockMaximo: 56,
    unidad: "unidad",
    ubicacionFisica: "Percha R3",
    proveedor: "Studio F Internacional",
    material: "95% viscosa, 5% elastano",
    colorProducto: "Floral multicolor",
    talla: "M",
    descripcionLarga:
      "Vestido midi estampado floral, tiras ajustables y vuelo en falda. Perfecto para primavera y eventos casuales.",
    especificaciones: [
      { clave: "Largo", valor: "Midi" },
      { clave: "Material", valor: "Viscosa stretch" },
    ],
    imageKeywords: ["floral-dress", "summer-dress", "midi-dress"],
    color: "bg-pink-400",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Saco Hoodie Unisex",
    marca: "Adidas",
    modelo: "Essentials 3-Stripes",
    origen: "Vietnam",
    costo: 95000,
    precio: 149000,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Percha R4",
    proveedor: "Adidas Colombia",
    material: "80% algodón, 20% poliéster",
    colorProducto: "Gris jaspe",
    talla: "L",
    descripcionLarga:
      "Hoodie clásico con capucha ajustable, bolsillo canguro y logo Adidas bordado. Interior felpa para abrigar.",
    especificaciones: [
      { clave: "Capucha", valor: "Ajustable" },
      { clave: "Material", valor: "Fleece algodón" },
    ],
    imageKeywords: ["gray-hoodie", "sweatshirt", "adidas-hoodie"],
    color: "bg-slate-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Short Deportivo Hombre",
    marca: "Nike",
    modelo: "Dri-FIT Challenger",
    origen: "Vietnam",
    costo: 58500,
    precio: 89900,
    stock: 45,
    stockMinimo: 10,
    stockMaximo: 90,
    unidad: "unidad",
    ubicacionFisica: "Percha R5, deportivo",
    proveedor: "Nike Colombia",
    material: "100% poliéster Dri-FIT",
    colorProducto: "Negro",
    talla: "M",
    descripcionLarga:
      "Short de running con tecnología Dri-FIT, malla interior integrada y bolsillos laterales con cierre.",
    especificaciones: [
      { clave: "Largo", valor: "18cm" },
      { clave: "Tecnología", valor: "Dri-FIT" },
    ],
    imageKeywords: ["sport-shorts", "running-shorts", "nike-shorts"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Leggings Deportivos Mujer",
    marca: "Lululemon",
    modelo: 'Align 25"',
    origen: "Vietnam",
    costo: 185000,
    precio: 289000,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "unidad",
    ubicacionFisica: "Percha R5",
    proveedor: "Lululemon Colombia",
    material: "Nulu 81% nylon, 19% elastano",
    colorProducto: "Negro",
    talla: "S",
    descripcionLarga:
      "Leggings Align de tela Nulu ultra suave, corte high-rise, sin costuras incómodas. Perfecto para yoga y entrenamiento.",
    especificaciones: [
      { clave: "Tiro", valor: "Alto" },
      { clave: "Largo", valor: "25 pulgadas" },
    ],
    imageKeywords: ["leggings", "yoga-pants", "black-leggings"],
    color: "bg-slate-900",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Chaqueta Jean Unisex",
    marca: "Levi's",
    modelo: "Trucker Classic",
    origen: "México",
    costo: 125000,
    precio: 195000,
    stock: 22,
    stockMinimo: 6,
    stockMaximo: 44,
    unidad: "unidad",
    ubicacionFisica: "Percha R4",
    proveedor: "Levi Strauss Colombia",
    material: "100% algodón denim",
    colorProducto: "Azul medio",
    talla: "M",
    descripcionLarga:
      "Chaqueta de jean clásica trucker con bolsillos pecho y broches metálicos. Versátil para cualquier look.",
    especificaciones: [
      { clave: "Material", valor: "Denim rígido" },
      { clave: "Cierre", valor: "Broches" },
    ],
    imageKeywords: ["denim-jacket", "jean-jacket", "levis-jacket"],
    color: "bg-blue-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Camisa Formal Hombre",
    marca: "Arturo Calle",
    modelo: "Slim Stretch",
    origen: "Colombia",
    costo: 65000,
    precio: 98900,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Percha R6, formal",
    proveedor: "Arturo Calle S.A.S.",
    material: "70% algodón, 28% poliéster, 2% elastano",
    colorProducto: "Blanco",
    talla: "M",
    descripcionLarga:
      "Camisa formal slim fit con mínimo planchado. Cuello italiano, puños con botón. Ideal oficina o eventos.",
    especificaciones: [
      { clave: "Corte", valor: "Slim fit" },
      { clave: "Cuello", valor: "Italiano" },
    ],
    imageKeywords: ["formal-shirt", "white-shirt", "dress-shirt"],
    color: "bg-white",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Pijama Algodón Mujer 2pzs",
    marca: "Leonisa",
    modelo: "Comfort Sleep",
    origen: "Colombia",
    costo: 48500,
    precio: 74900,
    stock: 35,
    stockMinimo: 8,
    stockMaximo: 70,
    unidad: "set",
    ubicacionFisica: "Percha R7",
    proveedor: "Leonisa S.A.",
    material: "100% algodón peinado",
    colorProducto: "Azul cielo",
    talla: "M",
    descripcionLarga:
      "Set pijama femenina 2 piezas: blusa manga corta y pantalón largo. Algodón ultra suave. Perfecta para dormir fresca.",
    especificaciones: [
      { clave: "Piezas", valor: "2" },
      { clave: "Material", valor: "Algodón peinado" },
    ],
    imageKeywords: ["pajamas", "womens-pjs", "sleepwear"],
    color: "bg-sky-300",
    shape: "square",
  }),
];
